var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#09101A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1028 3.79289C13.7123 3.40237 13.0791 3.40237 12.6886 3.79289L3.14645 13.3351L3 13.4815V13.6886V15.9542V16.4542H3.5H5.7656H5.9727L6.11915 16.3078L15.6613 6.7656C16.0518 6.37507 16.0518 5.74191 15.6613 5.35138L14.1028 3.79289ZM4 15.4542V13.8957L13.3957 4.5L14.9542 6.05849L5.55849 15.4542H4ZM10.5067 15.4475H15.4933C15.7731 15.4475 16 15.6744 16 15.9542C16 16.2341 15.7731 16.461 15.4933 16.461H10.5067C10.2269 16.461 10 16.2341 10 15.9542C10 15.6744 10.2269 15.4475 10.5067 15.4475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1d6bbfeff32e1b44dd22f25b38858913.svg";
export { ForwardRef as ReactComponent };